import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as ProxyGroupActions from '../proxy-group/proxy-group.action';
import { Constants } from 'src/app/helper/constants';
import { IGroupResult } from 'src/app/models/proxy-group';
import { ProxyService } from 'src/app/core/services/proxy.service';

@Injectable()
export class ProxyGroupEffects {
  constructor(private http: HttpClient, private action$: Actions, private proxyGroupService: ProxyService) { }

  private ApiURL = Constants.PROXY_GROUP;

  GetProxyGroup$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(ProxyGroupActions.GetGroupsApiAction),
      mergeMap(action =>
        this.proxyGroupService.getProxy().pipe(
          map((data: IGroupResult) => {
            return ProxyGroupActions.SuccessGetProxyGroupsApiAction({ groupObj: data });
          }),
          catchError((error: Error) => {
            return of(ProxyGroupActions.ErrorGetProxyGroupsApiAction(error));
          })
        )
      )
    )
  );
}
